import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { CpoModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/cpos/cpo.model';

import { useAppSelector } from '@app/core/hooks';
import { useEmspBoGetCpoQuery } from '@app/core/service/emsp-bo-cpo.service';
import { emspBoCpoSlice } from '@app/core/service/emsp-bo-cpo.slice';

export interface EmspBoCpoFilterStateControllerProps {
  value: CpoModel['id'];
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoCpoFilterStateController = ({
  value,
  onRemove,
}: EmspBoCpoFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const cpo = useAppSelector((state) =>
    emspBoCpoSlice.selectors.selectById(state, value),
  );

  const { data: cpoApiData } = useEmspBoGetCpoQuery(
    { cpoId: value },
    {
      skip: !!cpo,
    },
  );

  const cpoName = `${cpo?.id ?? cpoApiData?.id} - ${cpo?.endpoint ?? cpoApiData?.endpoint}`;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <FilteredItem icon="wifi" label={cpoName} onRemove={onRemove} />;
};
